import React from 'react';

export function IconHighlight() {
	return (
		<svg width="12" height="12" viewBox="0 0 32 32">
			<path d="M0.1875 1.71875L0.1875 30.3125L31.875 30.3125L31.875 1.71875L0.1875 1.71875ZM16 5.09375C16.6657 5.09375 17.3316 5.48537 17.625 6.21875L24.8438 24.2188L25.625 24.2188C26.3154 24.2188 26.875 24.7784 26.875 25.4688C26.875 26.1591 26.3154 26.7188 25.625 26.7188L20.8125 26.7188C20.1221 26.7188 19.5625 26.1591 19.5625 25.4688C19.5625 24.7784 20.1221 24.2188 20.8125 24.2188L21.0938 24.2188L19.6875 20.7188L12.3438 20.7188L10.9375 24.2188L11.2188 24.2188C11.9091 24.2188 12.4688 24.7784 12.4688 25.4688C12.4688 26.1591 11.9091 26.7188 11.2188 26.7188L6.40625 26.7188C5.71589 26.7188 5.15625 26.1591 5.15625 25.4688C5.15625 24.7784 5.71589 24.2188 6.40625 24.2188L7.1875 24.2188L14.375 6.21875C14.6684 5.48537 15.3343 5.09375 16 5.09375ZM16 11.5625L13.3438 18.2188L18.6562 18.2188L16 11.5625Z" fill="currentColor"/>
		</svg>
	);
}

export function IconUnderline() {
	return (
		<svg width="12" height="12" viewBox="0 0 32 32">
			<path d="M16.0625 2.5625C15.4919 2.5625 14.9389 2.87139 14.6875 3.5L7.53125 21.4062C7.51046 21.4582 7.5461 21.5099 7.53125 21.5625L6.53125 21.5625C5.97897 21.5625 5.53125 22.0102 5.53125 22.5625C5.53125 23.1148 5.97897 23.5625 6.53125 23.5625L11.3125 23.5625C11.8648 23.5625 12.3125 23.1148 12.3125 22.5625C12.3125 22.0102 11.8648 21.5625 11.3125 21.5625L10.6875 21.5625L12.2812 17.5938L19.875 17.5938L21.4688 21.5625L20.8438 21.5625C20.2915 21.5625 19.8437 22.0102 19.8438 22.5625C19.8438 23.1148 20.2915 23.5625 20.8438 23.5625L25.625 23.5625C26.1773 23.5625 26.625 23.1148 26.625 22.5625C26.625 22.0102 26.1773 21.5625 25.625 21.5625L24.625 21.5625C24.6104 21.5099 24.6458 21.4582 24.625 21.4062L17.4688 3.5C17.2173 2.87139 16.6331 2.5625 16.0625 2.5625ZM16.0938 8.09375L19.0938 15.5938L13.0938 15.5938L16.0938 8.09375ZM2.4375 26.5312L2.4375 29.5625L29.5938 29.5625L29.5938 26.5312L2.4375 26.5312Z" fill="currentColor" opacity="1" stroke="none"/>
		</svg>
	);
}

export function IconNote() {
	return (
		<svg width="12" height="12" viewBox="0 0 12 12">
			<path fill="currentColor" d="M0,7H5v5ZM0,0V6H6v6h6V0Z"/>
		</svg>
	);
}

export function IconArea() {
	return (
		<svg width="12" height="12" viewBox="0 0 12 12">
			<path fill="currentColor" d="M2,7V2H7V7Zm8,2V7H9V9H7v1H9v2h1V10h2V9ZM1,1H9V6h1V0H0V10H6V9H1Z"/>
		</svg>
	);
}

export function IconInk() {
	return (
		<svg width="12" height="12" viewBox="0 0 12 12">
			<path
				strokeWidth="1.8"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit="4"
				stroke="currentColor"
				fill="none"
				d="M 11.075423,10.940982 C 2.1007834,10.74643 3.2046232,-0.13478446 9,1.2287624 11.152259,2.2537259 10.06085,4.0872195 9,4.5910025 6.1497195,6 2.0752684,4.9659656 0.95896126,1.3633774"
			/>
		</svg>
	);
}

export function IconText() {
	return (
		<svg width="12" height="12" viewBox="0 0 12 12">
			<path
				d="M1.4375 0.4375C1.15866 0.4375 0.9375 0.658658 0.9375 0.9375L0.9375 2.46875C0.9375 2.74759 1.15866 2.96875 1.4375 2.96875L1.9375 2.96875C2.21634 2.96875 2.4375 2.74759 2.4375 2.46875L2.4375 1.9375L4.96875 1.9375L4.96875 10.0312L4.46875 10.0312C4.18991 10.0313 3.9375 10.2524 3.9375 10.5312L3.9375 11.0312C3.9375 11.3101 4.18991 11.5625 4.46875 11.5625L5.96875 11.5625L7.5 11.5625C7.77884 11.5625 8 11.3101 8 11.0312L8 10.5312C8 10.2524 7.77884 10.0312 7.5 10.0312L7 10.0312L7 1.9375L9.5 1.9375L9.5 2.46875C9.5 2.74759 9.72116 2.96875 10 2.96875L10.5312 2.96875C10.8101 2.96875 11.0312 2.74759 11.0312 2.46875L11.0312 0.9375C11.0312 0.658658 10.8101 0.4375 10.5312 0.4375L10.0312 0.4375L5.96875 0.4375L1.9375 0.4375L1.4375 0.4375Z"
				fill="currentColor"
				fillRule="nonzero"
				opacity="1"
				stroke="none"
			/>
		</svg>
	);
}

export function IconNoteLarge() {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24">
			<polygon fill="currentColor" points="0.5 0.5 23.5 0.5 23.5 23.5 11.5 23.5 0.5 12.5 0.5 0.5"/>
			<polygon points="0.5 12.5 11.5 12.5 11.5 23.5 0.5 12.5" fill="#fff" opacity="0.4"/>
			<path d="M0,0V12.707L11.293,24H24V0ZM11,22.293,1.707,13H11ZM23,23H12V12H1V1H23Z"/>
		</svg>
	);
}

export function IconColor20({ color }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
			<rect x="2" y="2" width="16" height="16" rx="2" fill={color}/>
			<rect x="2.5" y="2.5" width="15" height="15" rx="1.5" stroke="currentColor" strokeOpacity="0.1"/>
		</svg>
	);
}

export function IconColor16({ color }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
			<path d="M1 3C1 1.89543 1.89543 1 3 1H13C14.1046 1 15 1.89543 15 3V13C15 14.1046 14.1046 15 13 15H3C1.89543 15 1 14.1046 1 13V3Z" fill={color}/>
			<path d="M1.5 3C1.5 2.17157 2.17157 1.5 3 1.5H13C13.8284 1.5 14.5 2.17157 14.5 3V13C14.5 13.8284 13.8284 14.5 13 14.5H3C2.17157 14.5 1.5 13.8284 1.5 13V3Z" stroke="black" strokeOpacity="0.1"/>
		</svg>
	);
}

// https://raw.githubusercontent.com/FortAwesome/Font-Awesome/6.x/svgs/solid/user.svg
export function IconUser() {
	return (
		<svg width="8" viewBox="0 0 448 512">
			<path fill="currentColor"
				  d="M224 256c70.7 0 128-57.31 128-128s-57.3-128-128-128C153.3 0 96 57.31 96 128S153.3 256 224 256zM274.7 304H173.3C77.61 304 0 381.6 0 477.3c0 19.14 15.52 34.67 34.66 34.67h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304z"/>
		</svg>
	);
}

export function IconTreeItemCollapsed() {
	return (
		<svg width="16" height="16">
			<path fill="currentColor" d="M13 9L6 5v8z"/>
		</svg>
	);
}

export function IconTreeItemExpanded() {
	return (
		<svg width="16" height="16">
			<path fill="currentColor" d="M10 13l4-7H6z"/>
		</svg>
	);
}

export function IconTagCircle({ color }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
			<circle cx="4" cy="4" r="4" fill={color}/>
		</svg>
	);
}
